import { useState } from 'react';
import { ActionSheet } from 'antd-mobile';
import { useTranslation } from 'react-i18next';
import { setDriverLanguage, type DriverLanguage } from '../i18n';

interface LanguageSwitcherProps {
  className?: string;
}

/** Compact language switcher for login and profile. Default language is English. */
export function LanguageSwitcher({ className }: LanguageSwitcherProps) {
  const { t, i18n } = useTranslation();
  const [visible, setVisible] = useState(false);
  const current: DriverLanguage = i18n.language === 'zh-CN' ? 'zh-CN' : 'en';

  const actions = [
    {
      text: t('common.langEn'),
      key: 'en',
      disabled: current === 'en',
      onClick: () => {
        void setDriverLanguage('en');
        setVisible(false);
      },
    },
    {
      text: t('common.langZh'),
      key: 'zh-CN',
      disabled: current === 'zh-CN',
      onClick: () => {
        void setDriverLanguage('zh-CN');
        setVisible(false);
      },
    },
  ];

  return (
    <>
      <button
        type="button"
        className={className ?? 'driver-lang-switcher'}
        aria-label={t('common.language')}
        onClick={() => setVisible(true)}
      >
        {current === 'zh-CN' ? t('common.langZh') : t('common.langEn')}
      </button>
      <ActionSheet
        visible={visible}
        actions={actions}
        cancelText={t('common.cancel')}
        onClose={() => setVisible(false)}
      />
    </>
  );
}

export default LanguageSwitcher;
